<template>
  <div>
    <div v-if="action.responseType === actionResponseType.Text">
      <div v-if="action.type === actionType.Get">{{ action.result }}</div>
      <div v-if="action.type === actionType.Post">{{ action.postResult }}</div>
    </div>

    <div v-if="action.responseType === actionResponseType.Html">
      <div v-if="action.type === actionType.Get" v-html="action.result"></div>
      <div v-if="action.type === actionType.Post" v-html="action.postResult"></div>
    </div>

    <div v-if="action.responseType === actionResponseType.Json">
      <pre>{{ prettyJson }}</pre>
    </div>

    <div v-if="action.responseType === actionResponseType.CrewContactInformation">
      <CrewContactInformation :data="jsonData"></CrewContactInformation>
    </div>

    <div v-if="action.responseType === actionResponseType.GroundOpsFlightInformation">
      <GroundOpsFlightInformation :data="jsonData"></GroundOpsFlightInformation>
    </div>

    <div v-if="action.responseType === actionResponseType.CommercialDelay">
      <BoardItemDelayInfo v-model="jsonData"></BoardItemDelayInfo>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { IBoardItemActionDto, ActionResponseTypeDto, ActionTypeDto } from '@/apiclient/apiclient_generated';
  import CrewContactInformation from '@/components/BoardItemActions/ActionResponseTypes/CrewContactInformation.vue';
  import GroundOpsFlightInformation from '@/components/BoardItemActions/ActionResponseTypes/GroundOpsFlightInformation.vue';
  import BoardItemDelayInfo from '@/components/BoardItem/BoardItemDelayInfo.vue';

  @Component({
    components: {
      GroundOpsFlightInformation,
      CrewContactInformation,
      BoardItemDelayInfo,
    },
  })
  export default class ActionResultData extends Vue {
    @Prop()
    action: IBoardItemActionDto;
    actionResponseType = ActionResponseTypeDto;
    actionType = ActionTypeDto;

    get jsonData(): any {
      const result = JSON.parse(this.action.result);

      return result;
    }

    get prettyJson() {
      return JSON.stringify(this.jsonData, null, 2);
    }
  }
</script>

<style scoped lang="scss">
  pre {
    border: 1px solid grey;
    border-left: 5px solid #357ebd;
    border-radius: 5px;
    line-height: 24px;
    background-image: linear-gradient(180deg, #eee 50%, #fff 50%);
    background-size: 100% 48px;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
</style>
